import styled from '@emotion/styled'
import ChecIcon from 'components/patterns/Icon'

export const WarningIcon = styled(ChecIcon)`
  &&.chec-icon--warning_solid_black path:nth-of-type(2) {
    fill: rgba(7, 7, 15, 0.87);
  }
`

export const FeatureInfoPanel = styled.div`
  margin-bottom: 16px;
`

export const FeatureInfoRow = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 4px;
  font-size: 13px;

  &:last-child {
    margin-bottom: 0;
  }
`

export const FeatureInfoLabel = styled.span`
  color: var(--Black-Black-Secondary, rgba(7, 7, 15, 0.7));
  font-family: Arial;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px;
`

export const FeatureInfoValue = styled.span`
  color: var(--Black-Black-Secondary, rgba(7, 7, 15, 0.7));
  font-family: Arial;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
`

export const ModalTitle = styled.h2`
  color: var(--Black-Black-Primary, rgba(7, 7, 15, 0.87));
  font-family: Arial;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  margin: 0;
`

export const OutputSectionHeader = styled.h4`
  color: var(--Black-Black-Secondary, rgba(7, 7, 15, 0.7));
  font-family: Arial;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px;
  margin: 0 0 8px;
`

const selectSizeReset = `
  .ant-select-selection--single {
    height: 32px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .ant-select-selection__rendered {
    line-height: 30px;
    margin-top: 0;
    margin-bottom: 0;
  }
`

const fieldLabelStyles = `
  label {
    color: var(--Black-Black-Secondary, rgba(7, 7, 15, 0.70));
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: Arial;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
  }
`

export const FieldGroup = styled.div`
  display: grid;
  grid-template-columns: 150px 250px;
  gap: 16px;
  margin-bottom: 8px;
  align-items: start;
  ${selectSizeReset}
  ${fieldLabelStyles}
`

export const Code35MRow = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 100px);
  gap: 16px;
  margin-bottom: 8px;
  align-items: start;
  ${selectSizeReset}
  ${fieldLabelStyles}
`

// ─── Side panel ──────────────────────────────────────────────────────────────

export const OutputTileList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 0;
  width: 100%;
`

export const OutputTile = styled.button`
  all: unset;
  cursor: pointer;
  border-left: 3px solid
    ${({ selected }) => (selected ? '#1890ff' : 'transparent')};
  padding: 16px 25px;
  background-color: ${({ selected }) => (selected ? '#f5f5f5' : '#fff')};
  text-align: left;
  transition: background-color 0.15s, border-color 0.15s;
  box-sizing: border-box;
  width: 100%;

  &:hover {
    background-color: #f5f5f5;
  }
`

export const OutputTileTitle = styled.div`
  color: var(--Black-Black-Primary, rgba(7, 7, 15, 0.87));
  font-family: Arial;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  margin-bottom: 6px;
`

export const OutputTileSubtext = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--Black-Black-Secondary, rgba(7, 7, 15, 0.7));
  font-family: Arial;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px;

  svg {
    width: 20px !important;
    height: 20px !important;
  }
`

// ─── Filters form ────────────────────────────────────────────────────────────

export const FilterSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const FilterLabel = styled.div`
  color: var(--Black-Black-Secondary, rgba(7, 7, 15, 0.7));
  font-family: Arial;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
`

export const HorizontalRadioGroupWrapper = styled.div`
  .ant-radio-group {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 16px;
  }

  label {
    margin-top: 0 !important;
  }
`

export const SidePanelLabel = styled.div`
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #8c8c8c;
  padding: 12px 12px 4px;
`

export const LoadErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 32px;
  color: rgba(0, 0, 0, 0.65);
`
